import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-map-legend',
    templateUrl: './map-legend.component.html',
    styleUrls: ['./map-legend.component.scss']
})
export class MapLegendComponent {
    @Input() minLabel = 'Lower';
    @Input() maxLabel = 'Higher';
    @Input() title = 'Capex scale';
}
